import { render, staticRenderFns } from "./VehiclesDeclaration.vue?vue&type=template&id=aa4412f0&"
import script from "./VehiclesDeclaration.vue?vue&type=script&lang=js&"
export * from "./VehiclesDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports